<template>
	<v-container fill-height fluid class="pa-0">
		<Perfil :dadosIniciado="this.iniciado" :paises="this.listaPaises" :clas="listaClas" :perfis="listaPerfis" :status="listaStatus" />
		<NovoIniciado :propCla="cla"/>
			<v-row class="ma-0">
				<v-col cols="12" class="pa-0">
					<v-card tile :height="this.$store.getters.alturaContent" cols="12" :loading="loading">
						<v-card-title>
							<v-toolbar flat class="pt-3" dense>
								<v-select v-if="this.verificaAcesso(acessos.VISUALZIARTODOSCLAS) || this.verificaAcesso(acessos.VISUALIZARCLASPORCASA)" dense :items="clas" v-model="cla" label="Clã" outlined></v-select>
							</v-toolbar>
							<v-toolbar flat class="pt-3" dense>
								<v-spacer></v-spacer>
								<v-btn @click="cadastrarNovoIniciado()" color="primary" small>Novo</v-btn>
								<v-spacer class="d-sm-none"></v-spacer>
							</v-toolbar>
						</v-card-title>
						<v-card-text>
							<v-data-table :page.sync="pagina" hide-default-footer :height="this.$store.getters.alturaContent - 190" locale="pt-BR" dense fixed-header class="table-item" :items="iniciados" :headers="fields" :items-per-page="itensPorPagina">
								<!-- <template v-slot:item.data_inicio="{ item }">
									{{mostrarData(item.data_nascimento)}}
								</template>
								<template v-slot:item.data_inicio="{ item }">
									{{mostrarData(item.data_iniciacao)}}
								</template> -->
								<template v-slot:item.action="{ item }">
									<v-tooltip bottom>
										<template v-slot:activator="{on}">
											<v-btn v-on="on" text color="primary" id="btn-visualizar" @click.stop="visualizarIniciado(item.id_inic)"><v-icon>mdi-eye</v-icon></v-btn>
										</template>
										<span>Visualizar</span>
									</v-tooltip>
									<v-tooltip v-if="item.cod_status == 2"  bottom>
										<template v-slot:activator="{on}">
											<v-btn v-on="on" :disabled="!verificaAcesso(acessos.INATIVARUSUARIO)" text color="primary" id="btn-inativar" @click.stop="InativarIniciado(item.id_inic)"><v-icon>mdi-check</v-icon></v-btn>
										</template>
										<span>Inativar usuario</span>
									</v-tooltip>
									<v-tooltip v-if="item.cod_status == 3" bottom>
										<template v-slot:activator="{on}">
											<v-btn v-on="on" :disabled="!verificaAcesso(acessos.ATIVARUSUARIO)" text color="primary" id="btn-ativar" @click.stop="AtivarIniciado(item.id_inic)"><v-icon>mdi-close</v-icon></v-btn>
										</template>
										<span>Ativar usuario</span>
									</v-tooltip>
								</template>
							</v-data-table>
							<v-row>
								<v-col cols=12>
									<v-pagination :length="totalPaginas" total-visible="7" v-model="pagina">
									</v-pagination>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
	</v-container>
</template>

<script>

// precisa atualizar a classe ativo quando mudar o cla

	import { baseApiUrl, showError, showSuccess } from "@/config/global"
	import { mapState } from 'vuex'
	import axios from 'axios'
	import Perfil from '@/components/iniciados/Perfil'
	import NovoIniciado from '@/components/iniciados/NovoIniciado'
	import Br from '@/config/barramento.js'
	import ACESSOS from '@/Enums/Acessos.js'
	import metodos from '@/mixins/metodos'
	
	export default{
		name: 'Iniciados',
		mixins: [metodos],
		components: { Perfil, NovoIniciado},
		computed:{
			...mapState(['user', 'buscandoDados', 'iniciado']),
		},
		data(){
			return {
				acessos: ACESSOS,
				pagina: 1,
				itensPorPagina: 8,
				totalPaginas: 1,
				id_iniciado: '',
				cla: '1',
				clas: [],
				iniciados:[],
				fields: [
						{text: 'Nome', value: 'nome', align: 'center', divider: true},
						{text: 'Data Nascimento', value: 'data_nascimento', align: 'center', divider: true},
						{text: 'Data Iniciação', value: 'data_iniciacao', align: 'center', divider: true},
						{text: 'Grau', value: 'grau', align: 'center', divider: true},
						{text: 'Celular', value: 'celular', align: 'center', divider: true},
						{text: 'Ações', value: 'action', align: 'center', divider: true}
				],
				dados:{iniciado:{}},
				listaPerfis: {},
				listaStatus: {},
				listaPaises: {},
				listaClas: {},
				loading: false,
				
			}
		},

		methods:{
			InativarIniciado(item){
				const url = `${baseApiUrl}/iniciados/iniciado/inativar.php`

				axios.post(url, {id: item})
				.then(res => { 
					if(res.data.codigo == "01"){
						showSuccess(res.data.mensagem)

						this.iniciados.forEach(v => {
							if(v.id_inic == item){
								v.cod_status = 3
							}
						})

					}else{
						showError(res.data.mensagem)
					}
				})
				.catch({showError})
			},

			AtivarIniciado(item){
				const url = `${baseApiUrl}/iniciados/iniciado/ativar.php`

				axios.post(url, {id: item})
				.then(res => { 
					if(res.data.codigo == "01"){
						showSuccess(res.data.mensagem)

						this.iniciados.forEach(v => {
							if(v.id_inic == item){
								v.cod_status = 2
							}
						})



					}else{
						showError(res.data.mensagem)
					}
				})
				.catch({showError})
			},

			cadastrarNovoIniciado(){
				Br.setAbrirNovoIniciado('abrir')
			},

			podeAcessar(perfilIni, perfil){
				return perfilIni > perfil ? true : false
			 },

			carregaClas(){
				this.loading = true
				const url = `${baseApiUrl}/clas/read.php` 
				const params = {
					casas: this.user.dados.sexo,
					id_iniciado: this.user.user
				}

				axios.post(url, params)
					.then(res => { 
						if(this.verificaAcesso(ACESSOS.VISUALIZARPROPRIOCLA)){
							this.cla = res.data[0].value
						}
						this.clas = res.data
						this.carregaIniciados(this.cla, this.paginaAtual)
					})
					.catch({showError})
			},

			carregaIniciados(cla){
				this.loading = true
				const url = `${baseApiUrl}/iniciados/read.php`
				const params ={
					cla: cla,
				}

				axios.post(url, params)
					.then(res => {
						this.iniciados = res.data.dados
						
						this.iniciados.forEach(v=>{
							if(v.id_user == this.user.user){
								let idx = this.iniciados.findIndex(v=>{
									return v.id_user == this.user.user
								})
								
								this.iniciados.splice(idx, 1)
							}
						})
						
						this.totalPaginas = Math.ceil(this.iniciados.length / this.itensPorPagina)
						this.loading = false
					})
					.catch({showError})
			},

			visualizarIniciado(ini){
				this.buscarIniciado(ini)
			},


			buscarIniciado(id){
				
				if(id > 0){
					
					this.loading = true
					this.proprioPerfil = false

					const url = `${baseApiUrl}/iniciados/readOne.php?iniciado=${id}`
					
					
					axios.get(url)
						.then(res => {
							res.data.iniciado.dados.dtNascimento = this.converterData(res.data.iniciado.dados.dtNascimento)
							res.data.iniciado.dados.hrNascimento = res.data.iniciado.dados.dtNascimento
							res.data.iniciado.dados.dtIniciacao = this.converterData(res.data.iniciado.dados.dtIniciacao)
							this.$store.commit('setIniciado', res.data.iniciado)

							this.iniciado.passagens = res.data.iniciado.passagens.map( p => {
								return {
									...p,
									dataObj: this.converterData(p.data)
								}
							})

							this.iniciado.acessos = res.data.iniciado.acessos.map(a => {
								return {
									ativo: a.ativo == "1" ? true : false,
									id_perfil: a.id_perfil,
									nome: a.nome
								}
							})

							// this.iniciado.acessos.forEach(v => {
							// 		v = v.ativo == "1" ? true : false
							// 	})

							this.iniciado.clas = res.data.iniciado.clas.map( c => {
								return {
									... c,
									dataObj: this.converterData(c.data)
								}
							})
							this.iniciado.titulos = res.data.iniciado.titulos.map(t => {
								return {
									...t,
									dataObj: this.converterData(t.data)
								}
							})

							this.iniciado.clas.sort(this.compare)
							this.iniciado.clas.forEach((v, i) => {
								this.iniciado.clas[i].ordenacao = i + 1
							})

							Br.setAbrirIniciado('abrir');
							this.loading = false
						
						})
						.catch({showError})
						
				}else{
					this.$store.commit('setIniciado', this.$store.state.user)
					this.proprioPerfil = true
				}
				
			},

			converterData(dt){
				let data = new Date(dt)
				let difHorario = data.getTimezoneOffset() / 60
				data = new Date(data.setHours(data.getHours() + difHorario))
				
				return data
			},

			compare(a, b){
				if(this.converterData(a.data) < this.converterData(b.data)){
					return -1;
				}
				if(this.converterData(a.data) > this.converterData(b.data)){
					return 1;
				}
				
				return 0;
			}
			
		},

		created(){
			this.$store.commit('alteraBuscandoDados', true)

			// if(this.verificaAcesso(this.acessos.VISUALZIARTODOSCLAS) || this.verificaAcesso(this.acessos.VISUALIZARCLASPORCASA)){
			//	this.carregaClas()
			//}

			this.carregaClas()
			
			this.$store.commit('setIniciado', this.$store.state.iniciadoPadrao)

		},

		watch:{

			cla(val){
				this.carregaIniciados(val)
			}
		}
	}

</script>

<style scoped>

	
</style>